import styled from 'styled-components';

export const ChipSelectWrapper = styled.div`
  width: 100%;
  margin: 8px 0;

  .chip-select-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .chip-select-chip.chip-select-chip {
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    padding: 6px 10px !important;
    border: 1.5px solid #e5e7eb !important;
    border-radius: 8px !important;
    background: #ffffff !important;
    background-image: none !important;
    color: #374151 !important;
    font-family: inherit !important;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.4 !important;
    box-shadow: none !important;
    cursor: pointer !important;
    transition: border-color 0.15s ease, background-color 0.15s ease,
      color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease !important;
  }

  .chip-select-chip.chip-select-chip:hover:not(:disabled):not(.is-selected) {
    border-color: #c4b5fd !important;
    background: #ffffff !important;
  }

  .chip-select-chip.chip-select-chip.is-selected,
  .chip-select-chip.chip-select-chip.is-selected:hover {
    border-color: #8b5cf6 !important;
    background: #ffffff !important;
    color: #7c3aed !important;
  }

  .chip-select-chip.chip-select-chip:focus-visible {
    outline: none !important;
    box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.28) !important;
  }

  .chip-select-chip.chip-select-chip:disabled {
    cursor: default !important;
  }

  &.is-live .chip-select-chip.chip-select-chip:disabled {
    opacity: 0.6 !important;
  }

  .chip-select-label p {
    display: inline;
    margin: 0;
  }

  .chip-select-label a {
    color: inherit;
    text-decoration: underline;
  }

  .chip-select-label sub,
  .chip-select-label sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
  }

  .chip-select-label sup {
    top: -0.5em;
  }

  .chip-select-label sub {
    bottom: -0.25em;
  }

  .chip-select-media img {
    display: block;
    width: 100%;
    max-width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .chip-select-icon {
    flex-shrink: 0;
    margin-right: 6px;
    font-size: 1.15em;
    line-height: 1;
  }

  &&.chip-select-layout-list .chip-select-icon {
    margin-right: 0;
    font-size: 24px;
  }

  &&.chip-select-layout-cards .chip-select-icon {
    margin: 18px 0 0;
    font-size: 40px;
    text-align: center;
  }

  .chip-select-indicator {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 22px;
    height: 22px;
    border: 1.5px solid currentColor;
    border-radius: 50%;
    opacity: 0.35;
    transition: opacity 0.15s ease, background-color 0.15s ease;
  }

  .chip-select-indicator.is-square {
    border-radius: 6px;
  }

  .chip-select-indicator svg {
    color: #ffffff;
    opacity: 0;
    transition: opacity 0.15s ease;
  }

  .chip-select-chip.is-selected .chip-select-indicator {
    opacity: 1;
    border-color: currentColor;
    background: currentColor;
  }

  .chip-select-chip.is-selected .chip-select-indicator svg {
    opacity: 1;
  }

  &&.chip-select-layout-list .chip-select-list {
    flex-direction: column;
    flex-wrap: nowrap;
    gap: 12px;
  }

  &&.chip-select-layout-list .chip-select-chip.chip-select-chip {
    justify-content: flex-start !important;
    gap: 14px;
    width: 100%;
    min-height: 58px;
    padding: 14px 18px !important;
    border-radius: 14px !important;
    font-size: 16px !important;
    font-weight: 500 !important;
    text-align: left;
  }

  &&.chip-select-layout-list .chip-select-label {
    flex: 1;
    min-width: 0;
  }

  &&.chip-select-layout-list .chip-select-media {
    flex-shrink: 0;
    width: 44px;
    height: 44px;
    border-radius: 10px;
    overflow: hidden;
  }

  &&.chip-select-layout-cards .chip-select-list {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(min(140px, 100%), 1fr));
    gap: 14px;
    width: 100%;
    min-width: 0;
  }

  &&.chip-select-layout-cards .chip-select-chip.chip-select-chip {
    position: relative;
    flex-direction: column;
    align-items: stretch !important;
    justify-content: flex-start !important;
    width: 100%;
    min-width: 0;
    min-height: 96px;
    padding: 0 !important;
    border-radius: 16px !important;
    overflow: hidden;
    font-size: 16px !important;
    font-weight: 600 !important;
    text-align: center;
  }

  &&.chip-select-layout-cards .chip-select-media {
    display: block;
    width: 100%;
    min-width: 0;
    aspect-ratio: 1 / 1;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.03);
  }

  &&.chip-select-layout-cards .chip-select-label {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
    padding: 14px 12px;
  }

  &&.chip-select-layout-cards .chip-select-indicator {
    position: absolute;
    top: 10px;
    right: 10px;
    background: rgba(255, 255, 255, 0.9);
    border-color: rgba(255, 255, 255, 0.95);
    opacity: 1;
    box-shadow: 0 1px 4px rgba(15, 23, 42, 0.25);
  }

  &&.chip-select-layout-cards .chip-select-chip.is-selected .chip-select-indicator,
  &&.chip-select-layout-list .chip-select-chip.is-selected .chip-select-indicator {
    border-color: var(--chip-indicator, currentColor);
    background: var(--chip-indicator, currentColor);
  }

  &&.chip-select-layout-list .chip-select-chip.chip-select-chip:hover:not(:disabled):not(.is-selected),
  &&.chip-select-layout-cards .chip-select-chip.chip-select-chip:hover:not(:disabled):not(.is-selected) {
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(15, 23, 42, 0.08) !important;
  }

  &&.chip-select-layout-list .chip-select-chip.chip-select-chip.is-selected,
  &&.chip-select-layout-cards .chip-select-chip.chip-select-chip.is-selected {
    box-shadow: 0 0 0 1.5px currentColor !important;
  }

  .chip-select-custom-input {
    display: block;
    width: 100%;
    margin-top: 10px;
    box-sizing: border-box;
    border: 1px solid #c4c4c4;
    border-radius: 4px;
    padding: 8.5px 14px;
    font-size: 1rem;
    font-family: inherit;
    outline: none;
    transition: border-color 0.15s ease;

    &:focus {
      border-color: #8b5cf6;
    }
  }

  textarea.chip-select-custom-input {
    min-height: 90px;
    max-height: 640px;
    resize: vertical;
    overflow: auto;
  }

  &.has-error .chip-select-chip.chip-select-chip:not(.is-selected) {
    border-color: #d32f2f !important;
  }

  &.has-error .chip-select-custom-input {
    border-color: #d32f2f;
  }

  .chip-select-error-text {
    color: #d32f2f;
    font-size: 0.75rem;
    margin-top: 6px;
  }
`;
